// src/lib/datetime.js
export function toApiDateTime(input) {
  if (!input) return "";

  const value = String(input).trim();
  const match = value.match(/^(\d{4}-\d{2}-\d{2})[T\s](\d{2}:\d{2}:\d{2})/);

  if (match) {
    return `${match[1]} ${match[2]}`;
  }

  return value;
}

// "2026-10-15" / "2026-10-15 00:00:00" / ISO → "15 Oct 2026". Reads the
// calendar date as-is (no timezone shift); empty/zero/invalid dates → "".
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function toDisplayDate(input) {
  const m = String(input ?? "").trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return "";
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  if (y < 1971 || mo < 1 || mo > 12 || d < 1 || d > 31) return "";
  return `${d} ${MONTHS[mo - 1]} ${y}`;
}

export function toLocalDateTime(input, opts = {}) {
  if (!input) return "";

  // Normalize common backend formats:
  // - "YYYY-MM-DD HH:mm:ss"  (no timezone)
  // - "YYYY-MM-DDTHH:mm:ssZ" (ISO)
  // - "YYYY-MM-DDTHH:mm:ss+11:00" (ISO with offset)
  let s = String(input).trim();

  // If it's "YYYY-MM-DD HH:mm:ss", convert to ISO-like.
  // Note: without timezone info, this will be interpreted as LOCAL time.
  if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}$/.test(s)) {
    s = s.replace(" ", "T");
  }

  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return String(input);

  const locale = opts.locale; // undefined => browser locale
  const timeZone = opts.timeZone; // undefined => browser local timezone

  const dateStyle = opts.dateStyle ?? "medium";
  const timeStyle = opts.timeStyle ?? "short";

  return new Intl.DateTimeFormat(locale, {
    timeZone,
    dateStyle,
    timeStyle,
  }).format(d);
}

